import { BOT_MODES } from '../../view/WCABots/bot-constants';

export const DEFAULT_WCA_BOTFLOW_STATE = {
  botFlows: [],
  page: 0,
  limit: 30,
  selectedBotFlowId: null,
  totalbotflowCount: 0,
  nodes: [],
  edges: [],
  selectedNode: null,
  quickReplyNode: {},
  listNode: {},
  rootStepId: null,
  botFlowExists: false,
  loading: false,
  configScreenOpen: false,
  editNodeCache: null,
  isEditable: true,
  deletedOptionNodeEdgeCache: [],
  updatedEdgeChache: [],
  mode: BOT_MODES.NEW,
};
